import { useEffect, useState } from "react";
import { ref, onValue } from "firebase/database";
import { initializeApp as Init } from "firebase/app";
import { getDatabase as Real } from "firebase/database";
import { TextAlignment } from "@cloudinary/url-gen/qualifiers";
import { center } from "@cloudinary/url-gen/qualifiers/textAlignment";
import { text } from "@cloudinary/url-gen/qualifiers/source";
import { m } from "framer-motion";
const Config = {
    apiKey: "AIzaSyADp2ZMSmtgCH9Tf59UWx-lQCP9nvBo74U",
    authDomain: "the-friend-zone-cafe.firebaseapp.com",
    databaseURL: "https://the-friend-zone-cafe-default-rtdb.firebaseio.com",
    projectId: "the-friend-zone-cafe",
    storageBucket: "the-friend-zone-cafe.firebasestorage.app",
    messagingSenderId: "256729520580",
    appId: "1:256729520580:web:a35a9562699dc348b96c91"
};

const APP = Init(Config);
const Realtime = Real(APP);
const styles = {
  container: {
    height: "100vh",
    background: "#0f172a",
    color: "#fff",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    gap: "14px"
  },
  logo: {
    width: 160,
    marginBottom: 20
  },
  title: {
    width: 320,
    fontSize: 20,
    fontWeight: 600,
    textAlign: "center",
    marginBottom: 20
  },
  subtitle: {
    opacity: 0.7
  },
  progressBar: {
    width: 320,
    height: 10,
    background: "#1e293b",
    borderRadius: 20,
    overflow: "hidden",
    marginTop: 10
  },
  progressFill: {
    height: "100%",
    background: "#facc15",
    transition: "width 400ms ease"
  },
  percent: {
    marginTop: 6,
    fontSize: 14,
    opacity: 0.8
  }
};

const Inventory = () => {
  const [progress, setProgress] = useState(0);

  useEffect(() => {
    const panelRef = ref(Realtime, "Panel");

    const unsubscribe = onValue(panelRef, snapshot => {
      if (snapshot.exists()) {
        const value = Number(snapshot.val());
        setProgress(isNaN(value) ? 0 : Math.min(100, Math.max(0, value)));
      }
    });

    return () => unsubscribe();
  }, []);

  return (
    <div style={styles.container}>
      <img
        src="/Icons/Firebase.png"
        alt="Firebase"
        style={styles.logo}
      />

      <h2 style={styles.title}>
        Generating access rule files for this page
      </h2>

      <p style={styles.subtitle}>Please wait…</p>

      <div style={styles.progressBar}>
        <div
          style={{
            ...styles.progressFill,
            width: `${progress}%`
          }}
        />
      </div>

      <span style={styles.percent}>{progress}%</span>
    </div>
  );
};

export default Inventory;